import React from 'react';
import PropTypes from 'prop-types';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';

const NotificationBadge = ({ children, classes }) => (
  <Badge
    badgeContent={children}
    classes={{
      ...classes.badge,
      ...classes.root,
    }}
  >
    <Typography />
  </Badge>
);

NotificationBadge.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export default NotificationBadge;
